import apiFinance from '@/api/finance'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  updateFinanceStart: '[edit finance] Update finance start',
  updateFinanceSuccess: '[edit finance] Update finance success',
  updateFinanceFailure: '[edit finance] Update finance failure',
}

export const actionTypes = {
  updateFinance: '[edit finance] Update finance',
}

const mutations = {
  [mutationTypes.updateFinanceStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateFinanceSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateFinanceFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.updateFinance](context, {id, financeInput}) {
    context.commit(mutationTypes.updateFinanceStart)
    return new Promise((resolve) => {
      apiFinance
        .updateFinance(id, financeInput)
        .then((response) => {
          context.commit(mutationTypes.updateFinanceSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateFinanceFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
